import styled, { CreateStyled } from '@emotion/styled'
import React from 'react'

export type Theme = {
  color: {
    mainBg: string
    mainColor: string
    subColor: string
    subColor2: string
    accordion1: string
    subBg: string
    accordion2: string
    contentsBg: string
    tabBg: string
    disableBg: string
    btn: string
    gray: string
    modalTxt: string
    modalSubTxt: string
    modalDarkBg: string
    modalSubBg: string
    modalSubBg2: string
    modalred: string
    modalOrange: string
    modalyellow: string
    modalgray: string
    modalBlue: string
    modalBg: string
    themeTxt: string
    darkTxt: string
    matchTit1: string
    matchTit2: string
    primary: string
    primaryBg: string
    secondaryBg: string
    redBg: string
    blueBg: string
    select: string
    red: string
    blue: string
    pink: string
    disableTxt: string
    disableTxt2: string
    underover: string
    handicap: string
    purple: string
    yellow: string
    TP: string
    white: string
    whiteBg: string
  }
  border: {
    default: string
    secondery: string
    line: string
    inputLine: string
  }
  font: {
    xxlarge: string
    xlarge: string
    largeNum: string
    title: string
    large: string
    medium: string
    small: string
    tiny: string
  }
  fontW: {
    bold: string
    medium: string
    regular: string
  }
}

export interface ThemeProps {
  theme?: Theme
  primary?: boolean
  secondary?: boolean
  navy?: boolean
  sub?: boolean
  blue?: boolean
  gray?: boolean
  TP?: boolean
  circle?: boolean
  noRadius?: boolean
  float?: boolean
  visible?: boolean
  fontSize?: string
}
export interface ButtonProps {
  theme?: Theme
  className?: string
  ico?: React.ReactNode
  img?: string
  zIndex?: number
  flex?: boolean
  column?: boolean
  alignCenter?: boolean
  spaceBetween?: boolean
  width?: any
  minWidth?: any
  height?: any
  margin?: any
  padding?: any
  border?: string
  boxShadow?: string
  borderRadius?: any
  imgBorderRadius?: any
  txtAlignCenter?: boolean
  icoSize?: any
  icoColor?: string
  icoBgColor?: string
  icoRotate?: number
  rightIco?: boolean
  badge?: any
  badgeSize?: any
  badgeTop?: number
  badgeRight?: number
  text?: string[]
  color?: string
  contents?: React.ReactNode
  bold?: boolean
  fontSize?: string
  primary?: boolean
  secondary?: boolean
  navy?: boolean
  sub?: boolean
  blue?: boolean
  gray?: boolean
  darkgray?: boolean
  white?: boolean
  btn?: boolean
  main?: boolean
  TP?: boolean
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
}

export interface TabProps {
  theme?: Theme
  round?: boolean
  underline?: boolean
  whiteUnderline?: boolean
  box?: boolean
  whiteBox?: boolean
  leftAlign?: boolean
  fixed?: boolean
  childFixed?: boolean
  noHeader?: boolean
  // 베팅 내역 팝업에서 탭 개수가 유동적이라 calc 계산시 활용.
  tabCount?: number
  noNum?: boolean
  iconTab?: boolean
}

export default styled as CreateStyled<Theme>
